import type { Translations } from './de'

const ar: Translations = {
  'language.flag': '🇸🇾',
  'language.name': 'العربية',
  'navigation.home': 'الرئيسية',
  'navigation.language': 'اللغة',
  'navigation.openMenu': 'فتح القائمة',
  'navigation.closeMenu': 'إغلاق القائمة',
  'navigation.skipToContent': 'انتقل إلى المحتوى',
  'categories.sightseeing.name': 'المعالم السياحية',
  'categories.sightseeing.heading': 'أشهر المعالم السياحية في أوغسبورغ',
  'categories.sightseeing.lead': 'من مواقع التراث العالمي لليونسكو إلى الفوغيراي، تقدم أوغسبورغ أكثر مما تتوقع.',
  'categories.events.name': 'الفعاليات',
  'categories.events.heading': 'جميع الفعاليات في لمحة',
  'categories.events.lead': 'حفلات موسيقية وأسواق وجولات في المدينة: اكتشف ما يحدث في أوغسبورغ هذا الأسبوع.',
  'categories.blog.name': 'الأخبار',
  'categories.blog.heading': 'أخبار من أوغسبورغ',
  'categories.blog.lead': 'خلفيات وتاريخ المدينة وموضوعات راهنة للقراءة والمشاركة.',
  'categories.emptyTitle': 'لا يوجد شيء هنا بعد',
  'categories.emptyDescription': 'لا توجد صفحات في هذا القسم بعد. عُد قريبًا.',
  'home.title': 'مرحبًا بك في أوغسبورغ',
  'home.intro': 'سواء كانت رحلة سياحية أو رحلة عمل أو زيارة عائلية، ستجد هنا جميع المعلومات المهمة لوقتك في أوغسبورغ.',
  'home.sightseeing.eyebrow': 'مدينة من التراث العالمي لليونسكو',
  'home.sightseeing.title': 'اكتشف المعالم السياحية',
  'home.sightseeing.lead': 'من مواقع التراث العالمي لليونسكو إلى الفوغيراي، تقدم أوغسبورغ أكثر مما تتوقع.',
  'home.sightseeing.action': 'اكتشف الآن',
  'home.events.eyebrow': 'ماذا يحدث في أوغسبورغ؟',
  'home.events.title': 'ابحث عن الفعاليات',
  'home.events.lead': 'لا تفوّت بعد الآن الحفلات الموسيقية وأسواق السلع المستعملة والمهرجانات. على صفحة الفعاليات لدينا ستبقى دائمًا على اطلاع.',
  'home.events.action': 'جميع الفعاليات',
  'home.blog.eyebrow': 'حكايات من المدينة',
  'home.blog.title': 'أخبار ومعلومات مفيدة',
  'home.blog.lead': 'هنا تجد كل ما هو مهم عن أوغسبورغ، لتكون على اطلاع جيد خلال زيارتك.',
  'home.blog.action': 'إلى المدونة',
  'home.language.eyebrow': 'أوغسبورغ مدينة دولية',
  'home.language.title': 'انتقل إلى لغتك',
  'home.language.lead': 'هذا الموقع متاح بعدة لغات. هل تريد تغيير اللغة؟',
  'home.highlights.eyebrow': 'مختارة لك',
  'home.highlights.title': 'توصياتنا',
  'home.highlights.lead': 'لبداية جيدة جمعنا لك بعض أبرز معالم أوغسبورغ. قراءة ممتعة!',
  'search.placeholder': 'بحث...',
  'search.clear': 'مسح البحث',
  'search.label': 'البحث في الصفحات',
  'search.results': '{{count}} نتيجة لـ «{{query}}»',
  'search.emptyTitle': 'لا توجد نتائج',
  'search.emptyDescription': 'لم نعثر على أي شيء لهذا البحث. جرّب كلمة أخرى.',
  'pagination.label': 'الصفحات',
  'pagination.previous': 'الصفحة السابقة',
  'pagination.next': 'الصفحة التالية',
  'pagination.page': 'الصفحة {{page}}',
  'pagination.summary': 'عرض {{start}}–{{end}} من {{total}}',
  'page.back': 'رجوع',
  'page.readMore': 'اقرأ المزيد',
  'page.tableOfContents': 'في هذه الصفحة',
  'page.openInGoogleMaps': 'فتح في خرائط Google',
  'map.copyAddress': 'نسخ العنوان',
  'map.copied': 'تم النسخ',
  'map.copyFailed': 'تعذّر النسخ',
  'map.routeInGoogleMaps': 'المسار في خرائط Google',
  'map.zoomIn': 'تكبير',
  'map.zoomOut': 'تصغير',
  'map.showAll': 'عرض الكل',
  'attribution.toggle': 'إظهار المصادر أو إخفاؤها',
  'map.gestures.windows': 'استخدم Ctrl مع التمرير لتكبير الخريطة',
  'map.gestures.mac': 'استخدم ⌘ مع التمرير لتكبير الخريطة',
  'map.gestures.mobile': 'استخدم إصبعين لتحريك الخريطة',
  'map.loading': 'جارٍ تحميل الخريطة …',
  'map.failed': 'تعذّر تحميل الخريطة.',
  'map.showPlace': 'عرض {{name}} على الخريطة',
  'map.marker': '{{name}}، {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}، {{icon}}',
  'map.route.walkingTime': 'حوالي {{duration}} سيرًا على الأقدام',
  'map.route.stops': '{{count}} محطات',
  'map.route.leg': '{{distance}} · حوالي {{duration}}',
  'mapIcons.landmark': 'معلم سياحي',
  'mapIcons.church': 'كنيسة',
  'mapIcons.museum': 'متحف',
  'mapIcons.park': 'حديقة وطبيعة',
  'mapIcons.viewpoint': 'نقطة مشاهدة',
  'mapIcons.cafe': 'مقهى',
  'mapIcons.bar': 'بار',
  'mapIcons.restaurant': 'مطعم',
  'mapIcons.shop': 'تسوّق',
  'mapIcons.event': 'مكان فعاليات',
  'mapIcons.transport': 'مواصلات',
  'mapIcons.place': 'مكان',
  'footer.imprint': 'بيانات النشر',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.mediaLicense': 'حقوق الصور',
  'legal.bindingNote': 'هذه الترجمة لأغراض إعلامية فقط. النسخة الألمانية وحدها هي الملزمة قانونيًا.',
  'imprint.provider.heading': 'بيانات وفقًا للمادة 5 من قانون DDG',
  'imprint.contact.heading': 'التواصل',
  'imprint.contact.email': 'البريد الإلكتروني',
  'imprint.responsible.heading': 'المسؤول عن المحتوى وفقًا للمادة 18 الفقرة 2 من MStV',
  'privacy.intro': 'توضح سياسة الخصوصية هذه البيانات الشخصية التي تتم معالجتها عند زيارتك لهذا الموقع.',
  'privacy.controller.heading': 'المسؤول عن المعالجة',
  'privacy.controller.text': 'المسؤول عن معالجة البيانات على هذا الموقع هو:',
  'privacy.hosting.heading': 'الاستضافة',
  'privacy.hosting.text': 'يُستضاف هذا الموقع لدى مزود استضافة خارجي مقره في ألمانيا. توجد الخوادم في ألمانيا.',
  'privacy.serverLogs.heading': 'سجلات الخادم',
  'privacy.serverLogs.text': 'عند كل زيارة لهذا الموقع يحفظ الخادم تلقائيًا المعلومات التي يرسلها متصفحك: عنوان IP، وتاريخ الطلب ووقته، والصفحة المطلوبة، وحجم البيانات المنقولة، وعنوان الصفحة المحيلة، والمتصفح ونظام التشغيل. هذه البيانات ضرورية لتشغيل الموقع بشكل آمن ومستقر (المادة 6 الفقرة 1 البند f من اللائحة العامة لحماية البيانات) وتُحذف بعد 7 أيام كحد أقصى.',
  'privacy.analytics.heading': 'قياس عدد الزيارات',
  'privacy.analytics.text': 'لمعرفة الصفحات التي تُقرأ، نحصي مشاهدات الصفحات بأنفسنا، دون خدمات خارجية ودون ملفات تعريف الارتباط. عند فتح صفحة، يرسل متصفحك إلى خادمنا عنوانها فقط. ونحفظ لكل عنوان ولغة ويوم عدد المشاهدات فقط، مفصولًا بين المتصفحات والبرامج الآلية (برامج الزحف)، التي نميّزها من خلال معرّف المتصفح (user agent). لا يُحفظ لهذا الغرض عنوان IP الخاص بك ولا معرّف متصفحك ولا أي معلومات أخرى عنك، ولا يمكن الاستدلال على زوار بعينهم. إذا أرسل متصفحك إشارة "Global Privacy Control" أو "Do Not Track"، فلن تُحتسب زيارتك. تُحذف الأرقام بعد سنة واحدة. الأساس القانوني هو المادة 6 الفقرة 1 البند f من اللائحة العامة لحماية البيانات؛ ومصلحتنا المشروعة هي تحسين هذا الموقع.',
  'privacy.errorReports.heading': 'تقارير الأخطاء',
  'privacy.errorReports.text': 'إذا حدث خطأ تقني أثناء تحميل صفحة ما، يُرسل تلقائيًا بريد إلكتروني يتضمن معلومات عن الطلب الفاشل إلى مشغل الموقع. وقد يتضمن عنوان IP الخاص بك والعنوان المطلوب ومعلومات عن متصفحك. تُستخدم تقارير الأخطاء حصريًا لإصلاح الأخطاء (المادة 6 الفقرة 1 البند f من اللائحة العامة لحماية البيانات).',
  'privacy.cookies.heading': 'ملفات تعريف الارتباط',
  'privacy.cookies.text': 'يستخدم هذا الموقع فقط ملفات تعريف الارتباط الضرورية تقنيًا، اللازمة لجلستك وللحماية من الطلبات المزورة (CSRF). لا تحتوي على بيانات لأغراض التحليل أو الإعلان وتُحذف عند إغلاق متصفحك. الأساس القانوني هو المادة 25 الفقرة 2 رقم 2 من TDDDG بالاقتران مع المادة 6 الفقرة 1 البند f من اللائحة العامة لحماية البيانات؛ ولا يلزم الحصول على موافقة. لا تُستخدم أي خدمات تحليل أو تتبع خارجية؛ ويعمل قياس عدد الزيارات الموصوف أعلاه دون ملفات تعريف الارتباط.',
  'privacy.rights.heading': 'حقوقك',
  'privacy.rights.text': 'يحق لك:',
  'privacy.rights.access': 'الاطلاع على بياناتك المخزنة (المادة 15 من اللائحة العامة لحماية البيانات)',
  'privacy.rights.rectification': 'التصحيح (المادة 16 من اللائحة العامة لحماية البيانات)',
  'privacy.rights.erasure': 'المحو (المادة 17 من اللائحة العامة لحماية البيانات)',
  'privacy.rights.restriction': 'تقييد المعالجة (المادة 18 من اللائحة العامة لحماية البيانات)',
  'privacy.rights.portability': 'نقل البيانات (المادة 20 من اللائحة العامة لحماية البيانات)',
  'privacy.rights.objection': 'الاعتراض على المعالجة (المادة 21 من اللائحة العامة لحماية البيانات)',
  'privacy.rights.contact': 'لممارسة هذه الحقوق، أرسل ببساطة بريدًا إلكترونيًا إلى:',
  'privacy.complaint.heading': 'حق تقديم شكوى',
  'privacy.complaint.text': 'يحق لك تقديم شكوى إلى سلطة رقابية لحماية البيانات. السلطة المختصة هي المكتب البافاري للرقابة على حماية البيانات (BayLDA)، Promenade 18، 91522 Ansbach، ألمانيا.',
  'privacy.updated': 'آخر تحديث: أكتوبر 2026',
  'mediaLicense.intro': 'جميع الصور ومقاطع الفيديو والمستندات والمسارات على هذا الموقع مملوكة لـ Visit Augsburg. يمكنك استخدامها ومشاركتها وتعديلها بموجب ترخيص المشاع الإبداعي نَسب المُصنَّف 4.0 دولي (CC BY 4.0) – حتى لأغراض تجارية – بشرط أن تذكرنا كمصدر.',
  'mediaLicense.credit.heading': 'كيف تذكرنا كمصدر',
  'mediaLicense.credit.text': 'اعرض هذه الإشارة بشكل واضح بجوار الصورة أو الفيديو مباشرة:',
  'mediaLicense.credit.link': 'ضع رابطًا، قدر الإمكان، إلى الصفحة التي جاء منها المحتوى وإلى الترخيص. وإذا عدّلت محتوى ما، فاذكر ذلك.',
  'mediaLicense.ai.heading': 'مساعدو الذكاء الاصطناعي ومحركات البحث',
  'mediaLicense.ai.text': 'ينطبق هذا أيضًا على روبوتات الدردشة ومساعدي الذكاء الاصطناعي ومحركات البحث: من يعرض صورة أو فيديو من هذا الموقع يعرض معها الإشارة «{{credit}}». المؤلف والإشارة والترخيص مدرجة بصيغة يمكن للآلات قراءتها في كل ملف صورة (IPTC/XMP) وفي البيانات المنظمة (schema.org) لكل صفحة.',
  'mediaLicense.license.heading': 'الترخيص',
  'mediaLicense.license.text': 'يسري نص ترخيص المشاع الإبداعي:',
  'mediaLicense.license.link': 'CC BY 4.0 – نَسب المُصنَّف 4.0 دولي',
  'mediaLicense.scope.heading': 'ما لا يشمله الترخيص',
  'mediaLicense.scope.text': 'نصوص هذا الموقع ليست جزءًا من الترخيص. بيانات الخرائط مصدرها OpenStreetMap ومتاحة بموجب ترخيص Open Database License (© مساهمو OpenStreetMap).',
  'mediaLicense.contact': 'هل لديك أسئلة حول الاستخدام؟ أرسل بريدًا إلكترونيًا إلى:',
  'mediaLicense.updated': 'آخر تحديث: أكتوبر 2026',
  'gallery.previous': 'الصورة السابقة',
  'gallery.next': 'الصورة التالية',
  'gallery.showImage': 'عرض {{title}}',
  'video.play': 'تشغيل {{title}}',
  'videoGallery.summaryOne': 'فيديو واحد · {{minutes}} د',
  'videoGallery.summaryOther': 'عدد الفيديوهات: {{count}} · {{minutes}} د',
  'tags.unesco_heritage': 'تراث اليونسكو العالمي',
  'tags.landmark': 'معلم بارز',
  'tags.church_monastery': 'كنيسة ودير',
  'tags.museum_culture': 'متحف وثقافة',
  'tags.park_nature': 'حديقة وطبيعة',
  'tags.viewpoint': 'نقطة مشاهدة',
  'tags.accessible': 'سهل الوصول',
  'tags.free': 'مجاني',
  'tags.family_friendly': 'مناسب للعائلات',
  'tags.concert': 'حفل موسيقي',
  'tags.market': 'سوق',
  'tags.guided_tour': 'جولة بصحبة مرشد',
  'tags.festival': 'مهرجان',
  'tags.exhibition': 'معرض',
  'tags.sports': 'رياضة',
  'tags.open_air': 'في الهواء الطلق',
  'tags.city_history': 'تاريخ المدينة',
  'tags.tips_tricks': 'نصائح وحيل',
  'tags.interview': 'مقابلة',
  'tags.food_drink': 'طعام وشراب',
  'tags.seasonal': 'موسمي',
  'tags.behind_the_scenes': 'خلف الكواليس',
  'tags.event_recap': 'ملخص الفعالية',
}

export default ar
